import { TFunction } from 'react-i18next';

export const CLASS_CREATE_INSTRUCTOR_MISSING_ZOOM_CREDENTIALS = 3007;
export const CLASS_CREATE_NO_ASSOCIATED_USER_EMAIL = 3012;
export const CLASS_CREATE_NO_USER_FOR_TOKEN = 3013;
export const CLASS_CREATE_SESSIONS_ERROR = 3016;
export const CLASS_CREATE_MEETING_NOT_FOUND = 3017;
export const CLASS_CREATE_ZOOM_PASSWORD_ERROR = 3018;
export const CLASS_CREATE_ZOOM_ERROR = 3019;
export const CLASS_CREATE_MISSING_CLASS_RECORD = 3020;
export const CLASS_CREATE_DRAFT_ALREADY_PUBLISHED = 3021;
export const CLASS_CREATE_ZOOM_REFRESH_FAILURE = 3022;

const GENERIC_CLASS_CREATE_ERROR_CODE = 3100;

export const getClassErrorMessage = (t: TFunction, code: number = GENERIC_CLASS_CREATE_ERROR_CODE): string => {
    let description;

    switch (code) {
        case CLASS_CREATE_INSTRUCTOR_MISSING_ZOOM_CREDENTIALS:
            description = t('error.instructor-missing-zoom-credentials');
            break;
        case CLASS_CREATE_NO_ASSOCIATED_USER_EMAIL:
            description = t('error.no-associated-user-email');
            break;
        case CLASS_CREATE_NO_USER_FOR_TOKEN:
            description = t('error.no-user-for-token');
            break;
        case CLASS_CREATE_SESSIONS_ERROR:
            description = t('error.sessions-error');
            break;
        case CLASS_CREATE_MEETING_NOT_FOUND:
            description = t('error.meeting-not-found');
            break;
        case CLASS_CREATE_ZOOM_PASSWORD_ERROR:
            description = t('error.zoom-password-error');
            break;
        case CLASS_CREATE_ZOOM_ERROR:
            description = t('error.zoom-error');
            break;
        case CLASS_CREATE_MISSING_CLASS_RECORD:
            description = t('error.missing-class-record');
            break;
        case CLASS_CREATE_DRAFT_ALREADY_PUBLISHED:
            description = t('error.draft-already-published');
            break;
        case CLASS_CREATE_ZOOM_REFRESH_FAILURE:
            description = t('error.zoom-refresh-failure');
            break;
        default:
            description = t('error.generic');
            break;
    }

    return `${description} ${t('error.code', { code })}`;
};
